import { render } from "./ProductsCategoryItem.vue?vue&type=template&id=1cc39566"
import script from "./ProductsCategoryItem.vue?vue&type=script&lang=js"
export * from "./ProductsCategoryItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__